import 'angular';

import {
  downgradeComponent,
  downgradeInjectable
} from '@angular/upgrade/static';

import { AdminDashboardService }      from './admin-dashboard.service';
import { SessionManagementComponent } from './admin-dashboard.session-management.component';

angular.module('app-lite.admin-dashboard', [])
  .directive('worAdminDashboardSessionManagement', downgradeComponent({ component: SessionManagementComponent }))
  .service('adminDashboardApi', downgradeInjectable(AdminDashboardService));
